import type { AedAlertRowContext, NewEventAlertRowContext } from '../queues/store/queue-store';
import { soundAlertStore } from '../sounds/sound-alert-store';
import type { AlertContext } from '../sounds/audible-alerts';

/** The sound callbacks every event queue store passes to `QueueStore`. */
export function createEventQueueAlertCallbacks({
    context,
    currentUserId,
}: {
    context: AlertContext;
    currentUserId: number;
}) {
    return {
        playAedSoundForEvent: (eventId: number, rowContext: AedAlertRowContext) =>
            soundAlertStore.playOnceForEvent(eventId, {
                type: 'AED_ATTEMPTING_ACCEPTING',
                context,
                agencyTypeGlobalAttrId: rowContext.agencyTypeGlobalAttrId,
            }),
        onRemoveRows: (eventId: number) => soundAlertStore.removeSoundForEvent(eventId),
        playNewEventAlertSound: (rowId: number, rowContext: NewEventAlertRowContext) =>
            soundAlertStore.playOnceForEvent(rowId, {
                type: 'NEW_EVENT',
                context,
                isAed: rowContext.isAed,
                isCallTakenByCurrentUser:
                    rowContext.callTakerId !== undefined &&
                    rowContext.callTakerId === currentUserId,
                priorityId: rowContext.priorityId,
                agencyTypeGlobalAttrId: rowContext.agencyTypeGlobalAttrId,
            }),
    };
}
